import InvoiceDetails from '@/views/InvoiceDetails.vue';

const invoiceDetailsRoutes = [
  {
    path: '/invoice-details/:id',
    name: 'InvoiceDetails',
    component: InvoiceDetails,
  },
];

export default invoiceDetailsRoutes;
